import Product from './product';
import Sku from './sku';
import Offer from './offer';
import Proportion from './proportion';
export default { Product, Sku, Offer, Proportion };
